import { NpcLaunchDialog } from '@/components/admin/npc/launch/launch-dialog';
import type { LaunchTarget } from '@/lib/npc-launch';
import { Button } from '@pms-digital/design-system';
import { useState } from 'react';

/**
 * « Lancer » / « Lancer un rejeu » (npc.md §6.1): the button that opens the launch box on a target -
 * a NPC from its fiche, a bench from its row of the Bancs tab. The box is mounted only while it is
 * open, so its reads (the experiences, the catalog, the history of the models) are not paid by a
 * page that never launches.
 */

export interface NpcLaunchButtonProps {
  target: LaunchTarget;
  label: string;
  /** `secondary` is the solid bleu nuit of the fiche, `accent` the outlined one of a bench row. */
  variant?: 'secondary' | 'accent';
  'data-testid'?: string;
}

export function NpcLaunchButton({
  target,
  label,
  variant = 'accent',
  'data-testid': testId,
}: NpcLaunchButtonProps) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        type="button"
        variant={variant}
        size="sm"
        compact
        icon="play_arrow"
        data-testid={testId}
        onClick={() => setOpen(true)}
      >
        {label}
      </Button>
      {open ? <NpcLaunchDialog target={target} onClose={() => setOpen(false)} /> : null}
    </>
  );
}
